import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseModule, ThemingService } from '@ird/ng-base';
import { SharedDomainNgModule } from '@ird/ng-common';
import { IsExternalUrlPipe } from '@ird/ng-core';
import { WarrantyTermsComponent } from './components/warranty-terms/warranty-terms.component';
import { RegionSelectorComponent } from './components/region-selector/region-selector.component';
import { ProductCategorySelectorComponent } from './components/product-category-selector/product-category-selector.component';
import { BackbuttonDirective } from './directives/backbutton.directive';
import { ImageComponent } from './image/image.component';
import { MaterialModule } from './material.module';
import { PlacementCodeService } from './placementcode/placementcode.service';
import { GeolocationService } from './services/geolocation.service';
import { GtmService } from './services/gtm.service';
import { InteractionService } from './services/interaction.service';
import { KpiLogsService } from './services/kpi-logs.service';
import { LayoutService } from './services/layout.service';
import { NavigationService } from './services/navigation.service';
import { SpUserService } from './services/sp-user.service';
import { UrlService } from './services/url.service';

@NgModule({
  declarations: [ImageComponent, BackbuttonDirective, WarrantyTermsComponent, RegionSelectorComponent, ProductCategorySelectorComponent],
  providers: [
    GeolocationService,
    GtmService,
    PlacementCodeService,
    IsExternalUrlPipe,
    ThemingService,
    UrlService,
    LayoutService,
    KpiLogsService,
    NavigationService,
    SpUserService,
    InteractionService,
  ],
  imports: [CommonModule, BaseModule, ReactiveFormsModule, FormsModule, SharedDomainNgModule],
  exports: [
    ImageComponent,
    FormsModule,
    ReactiveFormsModule,
    BaseModule,
    MaterialModule,
    BackbuttonDirective,
    SharedDomainNgModule,
    WarrantyTermsComponent,
    RegionSelectorComponent,
    ProductCategorySelectorComponent,
  ],
})
export class SharedModule {}
